<template>
  <div>
    <div class="notification">
      <b-link
      @click="handleOpenSideBar"
      >
        {{ feedBackTitle }}
      </b-link>
      <form-side-bar
          :sb-model="ionaModel"
          :sb-id="sbId"
          :profile="profile"
          :my-app="myApp"
          comm-with="iona"
         @close-clicked="handleSidebarClose"
      />
    </div>
  </div>
</template>
<script>
import FormSideBar from "./formSideBar";
export default {
  name: "Feedback_Sidebar",
  components: {
    FormSideBar
  },
  props: {
    profile: {
      type: Object,
      default: null
    },
    myApp: {
      type: String,
      default: null
    },
    feedBackTitle: {
          type: String,
        default: "🐞"
    }
  },
  computed: {},
  methods: {
    handleOpenSideBar() {
      //@ToDO- Use Ref
      this.ionaModel = true;
    },
    handleSidebarClose() {
      this.ionaModel = false;
    },
  },
  mounted() {
    //Get Messages and Threads
  },
  data() {
    return {
      ionaModel: false,
      sbId: "feedback-sidebar",
      notificationPanel: false,
      showModalNotifications: true,
      mainProps: {
        blank: false,
        blankColor: "#fcc727",
        width: 50,
        height: 50,
        class: "m1"
      },
      mainPropsTopBar: {
        blank: false,
        blankColor: "#fcc727",
        width: 25,
        height: 25,
        class: "m1"
      }
    };
  }
};
</script>
<style lang="scss" scoped>
</style>
